// extracted by mini-css-extract-plugin
export default {"app":"GameShell_app__z41LB","main":"GameShell_main__UYrnz","content":"GameShell_content__Jce00"};